import { ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import capitalize from 'lodash/capitalize'
import { CertificateHistoryRow, CertificateRuleType, CertificateRuleTypeLabel, Option } from 'types'

export const certificateHistoryFieldNameRenderer =
  (field: keyof CertificateHistoryRow) => (cell: ICellRendererParams<CertificateHistoryRow>) => {
    const { data } = cell
    if (!data) {
      return PLACEHOLDER
    }

    const fieldName = data[field]

    if (fieldName === 'lessonIds') {
      return 'Lessons'
    }

    if (fieldName === 'courseIds') {
      return 'Courses'
    }

    return capitalize(fieldName as string)
  }

export const certificateHistoryCellValueRenderer =
  (fieldName: keyof CertificateHistoryRow, coursesOptions: Option[], lessonsOptions: Option[]) =>
  (cell: ICellRendererParams<CertificateHistoryRow>) => {
    const { data } = cell
    if (!data) {
      return PLACEHOLDER
    }
    const value = data[fieldName]

    if (data.field === 'courseIds') {
      const ids = (value as string).split(',')
      return ids
        .map((id) => {
          const course = coursesOptions.find((item) => item.value === Number(id))
          return course ? course.label : PLACEHOLDER
        })
        .join(', ')
    }

    if (data.field === 'lessonIds') {
      const ids = (value as string).split(',')
      return ids
        .map((id) => {
          const lesson = lessonsOptions.find((item) => item.value === Number(id))
          return lesson ? lesson.label : PLACEHOLDER
        })
        .join(', ')
    }

    if (data.field === 'type') {
      return CertificateRuleTypeLabel[value as CertificateRuleType] || PLACEHOLDER
    }

    return value
  }
